import { getCASPreferredLanguageCookie } from '@/helper/cookies.js'

export default () => {
    const lang = getCASPreferredLanguageCookie('CAS_PREFERRED_LANGUAGE')
    return (lang ?? 'de_DE').replace('_', '-')
}
